import { render, staticRenderFns } from "./Shifts2.vue?vue&type=template&id=cdb76696&lang=pug"
import script from "./Shifts2.vue?vue&type=script&lang=js"
export * from "./Shifts2.vue?vue&type=script&lang=js"
import style0 from "./Shifts2.vue?vue&type=style&index=0&id=cdb76696&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports